import React from 'react';
import { twoOptionsBenefits, twoOptionsSteps } from '../data/kit';
import { Section, SectionHeader } from './Shared';
import { Ghost, Pumpkin } from './HalloweenDecor';
export function TwoOptions() {
  return <Section id="opciones" tone="mint" decor={<>
          <Ghost className="absolute left-[4%] top-12 w-12 text-white md:w-16" data-id="element-269" data-mp="2fcts7e4mnin5" />
          <Pumpkin className="absolute bottom-12 right-[5%] w-12 text-brand-orange/30 md:w-14" data-id="element-270" data-mp="2abnxxbvbjnbi" />
        </>} data-id="element-268" data-mp="2fa7k9ddtr14e">
      <SectionHeader tag="✨ INCLUIDO EN TU KIT" tagVariant="white" title="¿En casa prefieren sustos o sonrisas?" subtitle="No hace falta que todos elijan lo mismo. El kit reúne personajes tenebrosos y divertidos para acompañar distintos gustos." data-id="element-271" data-mp="25exi8pnfetqm" />

      <ul className="mx-auto mt-10 grid max-w-3xl gap-3 sm:grid-cols-2 sm:gap-4" data-id="element-272" data-mp="1rm7izjivzsbk">
        {twoOptionsBenefits.map(benefit => <li key={benefit} className="rounded-2xl bg-white px-5 py-4 text-base font-bold text-brand-violet shadow-card md:text-lg" data-id="element-273" data-mp="1ml0b7kgqut4w">
            {benefit}
          </li>)}
      </ul>

      <p className="mx-auto mt-10 flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2 rounded-2xl bg-brand-violet px-6 py-5 text-center font-display text-lg font-extrabold tracking-wide text-brand-cream md:text-2xl" data-id="element-274" data-mp="1zhxp4iqfq27j">
        {twoOptionsSteps.map((step, index) => <React.Fragment key={step} data-id="element-275" data-mp="1uj4d6uqsqj9h" data-mpi={index}>
            {index > 0 && <span aria-hidden="true" className="text-brand-orange" data-id="element-276" data-mp="1ujmg2a7yrvqd">
                →
              </span>}
            <span data-id="element-277" data-mp="2i98hl4bt6n1j">{step}</span>
          </React.Fragment>)}
      </p>
    </Section>;
}